import React, { Fragment } from 'react';
import cn from 'classnames';
import OfferLandingsTable from './OfferLandingsTable';
import Card from '../../../../components/Card/Card';
import { FormattedMessage } from 'react-intl';
import { descSort } from '../../../../utils/utils';
import {
  Row,
  Col,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import OfferTargetAudience from '../../../../components/Offer/OfferTargetAudience';

// export default ({ landings, currency, transits, offer, site_key, connectOffer }) => {
//     return (
//         <Card>
//             <Card.Header>
//                 <FormattedMessage id="offer.landings-prelanders.title" defaultMessage="Landings/Prelanders" />
//             </Card.Header>
//             <Card.Body className="no-padding offer-landings">
//                 <Row>
//                     <Col className='offer-landings-col' lg='12' xl='6' >
//                         {landings.length > 0 && (
//                             <OfferLandingsTable
//                                 hover={true}
//                                 name='landings'
//                                 landings={descSort(landings, 'totalCr')}
//                                 currency={currency}
//                                 offer={offer}
//                                 site_key={site_key}
//                                 connectOffer={() => connectOffer(offer.id)}
//                             />
//                         )} </Col>
//                     <Col className='offer-landings-col' lg='12' xl='6' >
//                         {transits.length > 0 && (
//                             <OfferLandingsTable
//                                 hover={true}
//                                 name='prelanders'
//                                 landings={descSort(landings, 'totalCr')}
//                                 currency={currency}
//                                 offer={offer}
//                                 site_key={site_key}
//                                 connectOffer={() => connectOffer(offer.id)}
//                             />
//                         )}
//                     </Col>
//                 </Row>
//             </Card.Body>
//         </Card>
//     )
// }

export default class OfferLandings extends React.Component {
  state = {
    activeTab: 1,
    dropdownOpen: false,
  };

  setActiveTab = activeTab => {
    this.setState(() => ({
      activeTab,
    }));
  };

  dropdownItemClickHandler = index => {
    // this.setActiveTab(index + 1);
    this.setState(() => ({
      activeTab: index + 1,
      dropdownOpen: false,
    }));
  };

  toggleDropdown = () => {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  renderTabsControls = tabsControls => {
    const { activeTab } = this.state;

    return (
      <Nav tabs className="no-margin">
        {tabsControls.map(
          (control, index) =>
            control && (
              <NavItem key={index}>
                <NavLink
                  className={cn({ active: activeTab === index + 1 })}
                  onClick={() => {
                    this.setActiveTab(index + 1);
                  }}
                >
                  {control}
                </NavLink>
              </NavItem>
            ),
        )}
      </Nav>
    );
  };

  renderDropdown = tabsControls => {
    const { activeTab, dropdownOpen } = this.state;
    const title = tabsControls[activeTab - 1];
    return (
      <Dropdown isOpen={dropdownOpen} toggle={this.toggleDropdown} className={'nav-tabs-collapse'}>
        <DropdownToggle
          tag="span"
          data-toggle="dropdown"
          aria-expanded={dropdownOpen}
          className="dropdown-toggle"
        >
          {title}
        </DropdownToggle>
        <DropdownMenu>
          {tabsControls.length > 0 &&
            tabsControls.map(
              (navLink, index) =>
                navLink && (
                  <DropdownItem
                    tag="span"
                    key={`flow-tabs-dropdown-${index}`}
                    onClick={this.dropdownItemClickHandler.bind(null, index)}
                  >
                    {navLink}
                  </DropdownItem>
                ),
            )}
        </DropdownMenu>
      </Dropdown>
    );
  };

  render() {
    const { landings, currency, transits, offer, site_key, connectOffer, profile } = this.props;

    const panes = [
      <div className="landings-table-wrapper">
        {landings.length > 0 && (
          <div className="landing-table-item">
            <h6>
              <FormattedMessage id="offer.landings.title" defaultMessage="Landings" />
            </h6>
            <OfferLandingsTable
              hover={true}
              name="landings"
              landings={descSort(landings, 'totalCr')}
              currency={currency}
              offer={offer}
              site_key={site_key}
              connectOffer={() => connectOffer(offer.id)}
            />
          </div>
        )}
        {transits.length > 0 && (
          <div className="landing-table-item">
            <h6>
              <FormattedMessage id="offer.prelanders.title.theme_3" defaultMessage="Prelanders" />
            </h6>
            <OfferLandingsTable
              hover={true}
              name="prelanders"
              landings={descSort(transits, 'totalCr')}
              currency={currency}
              offer={offer}
              site_key={site_key}
              connectOffer={() => connectOffer(offer.id)}
            />
          </div>
        )}
      </div>,

      offer.offerStatsYandex && offer.offerStatsYandex.stats ? (
        <OfferTargetAudience audience={offer.offerStatsYandex.stats} profile={profile} />
      ) : null,
    ];

    const navItems = [
      <FormattedMessage id="offer.landings.tab.title" defaultMessage="Landings/prelanders" />,
      offer.offerStatsYandex && offer.offerStatsYandex.stats ? (
        <FormattedMessage id="offer.landings.tab.statistics" defaultMessage="Target audience" />
      ) : null,
    ];

    const { activeTab } = this.state;

    return (
      <Card>
        <Card.Header className="no-padding card-header--with-tabs">
          {this.renderTabsControls(navItems)}
          {this.renderDropdown(navItems)}
        </Card.Header>

        <Card.Body className="no-padding">
          <TabContent activeTab={activeTab}>
            {panes.length > 0 &&
              panes.map((pane, index) => (
                <TabPane key={index} tabId={index + 1}>
                  {pane}
                </TabPane>
              ))}
          </TabContent>
        </Card.Body>
      </Card>
    );
  }
}

/* <Card.Tabs
  title="offer.landings-prelanders.title"
  defaultMessage="Landings/Prelanders"
  navItems={navItems}
  panes={panes}
  activeTab={1}
  // className="offer-landings"
  noPadding={true}
  collapsing={true}
/> */
